import { Order } from '@/store/use-orders-store';
import { OrderStatus, OrderType } from '@/types';

export const getIsOrderOpposite = (
  order: Pick<Order, 'status' | 'reduceOnly'>,
) => {
  switch (order.status) {
    case OrderStatus.FILLED:
    case OrderStatus.PARTIALLY_FILLED:
      return order.reduceOnly;
    default:
      return false;
  }
};
